import { Box, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import React from 'react';

interface Props {
  open: boolean;
  email: string;
  onClose: () => void;
}

const ConfirmationSent: React.FC<Props> = ({ open, email, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      slotProps={{
        backdrop: {
          style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' },
        },
      }}
      PaperProps={{
        style: {
          backgroundColor: '#E7ECF2',
          borderRadius: '12px',
          width: '100%',
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '25px',
          right: '25px',
          cursor: 'pointer',
          width: '18px',
          height: '18px',
          backgroundImage: 'url("/assets/onBoarding/x.svg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
        aria-label="Close"
        role="button"
        onClick={onClose}
      />

      <DialogContent>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ height: '400px', width: '100%' }}
        >
          <Stack spacing={2} alignItems="center">
            <img
              src="/assets/onBoarding/mailSent.svg"
              alt="Mail Sent"
              style={{ width: '150px', height: '150px' }}
            />
            <Typography fontWeight={900} fontSize="14px" fontFamily="AlmoniDL">
              !היי, שלחנו לך מייל
            </Typography>
            <Stack alignItems="center">
              <Typography
                fontWeight={700}
                fontSize="14px"
                fontFamily="AlmoniDL"
              >
                כדי להשלים את תהליך ההרשמה ולהתחיל להשתמש במערכת
              </Typography>
              <Typography
                fontWeight={900}
                fontSize="14px"
                fontFamily="AlmoniDL"
              >
                :לחצו על הקישור במייל שנשלח אליכם לכתובת
              </Typography>
              <Typography
                fontWeight={700}
                fontSize="14px"
                fontFamily="AlmoniDL"
              >
                {email && email}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </DialogContent>

      <Box
        sx={{
          width: '100%',
          height: '55px',
          backgroundColor: '#343434',
          marginTop: 'auto',
          direction: 'rtl',
          display: 'flex',
        }}
      >
        <Stack direction="row" gap={1} alignItems="center" px={1}>
          <img
            src="/assets/onBoarding/info.svg"
            alt="Info"
            style={{ width: '30px', height: '30px' }}
          />
          <Stack>
            <Typography
              fontWeight={700}
              fontSize="14px"
              fontFamily="AlmoniDL"
              color="#FFF"
            >
              לא מוצאים את המייל?
            </Typography>
            <Typography
              fontWeight={700}
              fontSize="14px"
              fontFamily="AlmoniDL"
              color="#FFF"
            >
              בדקו בתיבת הספאם או חפשו את השולח no-reply@pielapay.com
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default ConfirmationSent;
